import Vue from 'vue';
import Vuelidate from 'vuelidate';
const {
    required,
    email,
    requiredIf
} = require('vuelidate/lib/validators');

import VueResource from 'vue-resource';
import Multiselect from 'vue-multiselect';

Vue.component('multiselect', Multiselect);

import {
    addTravelCompanion,
    AddTCvalidation
} from '../../mixins/mixin.add-travel-companion';

import {
    isUserLoggedIn,
    ApiUrls,
    dateNotInPastSingleDate,
    singleDateValidation,
    setItemSessionStorage,
    getItemSessionStorage,
    deleteSessionStore,
    SessionKeys,
    convertoEnDate
} from '../../helper-functions';

import Spinner from '../../components/components.spinner.vue';
import Snackbar from "../../components/components.snack-bar.vue";
import Checkbox from '../../components/components.checkbox.vue';
import "../../filters/filters.number-format";

Vue.use(Vuelidate);
Vue.use(VueResource);

const SearchForm = {
    fromAirportCode: '',
    toAirportCode: '',
    fromTravelDate: '',
    toTravelDate: '',
    language: '',
    airlineName: '',
    numOfRows: 10,
    page: 1,
    sortingOrder: 'asc',
    sortField: 'travelDate'
};
Vue.component('travel-companion-search', {
    mixins: [addTravelCompanion],
    components: {
        Spinner,
        'v-checkbox': Checkbox,
        Snackbar
    },
    data () {
        return {
            searchForm: {...SearchForm},
            isSearchFormSubmitted: false,
            isSearchApiInProgress: false,
            errors: [],
            search: {
                fromAirportId: null,
                toAirportId: null,
                airlineName: null,
                sortBy: 'travelDateAsc'
            }
        }
    },
    validations () {
        let validations = {
            searchForm: {
                fromTravelDate: {                    
                    dateNotInPastSingleDate,
                    singleDateValidation,
                    required: requiredIf(function () {
                        return this.searchForm.toTravelDate != '';
                    })
                },
                toTravelDate: {                    
                    singleDateValidation,
                    dateNotBeforeSearchFromDate
                }
            }
        };

        const self = this;
        validations = {
            ...validations,
            ...AddTCvalidation
        };

        if(this.searchForm.fromTravelDate) {
            validations.searchForm.toTravelDate.required = required;
        } else {
            delete validations.searchForm.toTravelDate.required;
        }      

        function dateNotBeforeSearchFromDate(val) {
            if (val && self.searchForm.fromTravelDate) {
                if (val) {
                    var dateToCheck1 = new Date(convertoEnDate(val));
                    var created = new Date(convertoEnDate(self.searchForm.fromTravelDate));

                    return created <= dateToCheck1;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }

        return validations;
    },
    created () {
        if(window.immiObj.errors && window.immiObj.errors.length) {
            this.errors = window.immiObj.errors;
            Vue.nextTick(() => scrollToBlock('#search-ads'));
        }
        if (window.immiObj.searchCriteria) {
            if (window.immiObj.searchCriteria.fromAirportCode) {
                this.search.fromAirportId = getItemSessionStorage(SessionKeys.travelCompanion.fromAirportCode);
                if(this.search.fromAirportId) {
                    this.search.fromAirportId = JSON.parse(this.search.fromAirportId);
                }
            }
            if (window.immiObj.searchCriteria.toAirportCode) {
                this.search.toAirportId = getItemSessionStorage(SessionKeys.travelCompanion.toAirportCode);
                if(this.search.toAirportId) {
                    this.search.toAirportId = JSON.parse(this.search.toAirportId);
                }
            }
            if (window.immiObj.searchCriteria.airlineName) {
                this.search.airlineName = getItemSessionStorage(SessionKeys.travelCompanion.airlineObj);
                if(this.search.airlineName) {
                    this.search.airlineName = JSON.parse(this.search.airlineName);
                }
            }
            if (window.immiObj.searchCriteria.language) {
                this.searchForm.language = window.immiObj.searchCriteria.language;
            }
            if (window.immiObj.searchCriteria.language) {
                this.searchForm.language = window.immiObj.searchCriteria.language;
            }
            this.searchForm.numOfRows = window.immiObj?.numOfRows || 10;
            this.searchForm.page = window.immiObj?.page || 1;
            this.searchForm.sortingOrder = window.immiObj.searchCriteria.sortingOrder;
            this.searchForm.sortField = window.immiObj.searchCriteria.sortField;
            switch (this.searchForm.sortField) {
                case 'hitCount':
                    this.search.sortBy = this.searchForm.sortingOrder == 'asc' ? 'viewsAsc' : 'viewsDsc';
                    break;
            
                default:
                    this.search.sortBy = this.searchForm.sortingOrder == 'asc' ? 'travelDateAsc' : 'travelDateDsc';
                    break;
            }
        }

        // Add #search-results to pagination
        Vue.nextTick(()=>{
            $(".page-item a").each((i, e) => {
                let href = $(e).attr('href');
                $(e).attr('href', (href + '#search-results'));
            })
        })
    },
    watch: {
        'search.sortBy' () {
            switch (this.search.sortBy) {
                case 'travelDateAsc':
                    this.searchForm.sortingOrder = 'asc';
                    this.searchForm.sortField = 'travelDate';
                    break;
                case 'travelDateDsc':
                    this.searchForm.sortingOrder = 'desc';
                    this.searchForm.sortField = 'travelDate';
                    break;
                case 'viewsAsc':
                    this.searchForm.sortingOrder = 'asc';
                    this.searchForm.sortField = 'hitCount';
                    break;
                case 'viewsDsc':
                    this.searchForm.sortingOrder = 'desc';
                    this.searchForm.sortField = 'hitCount';
                break;
            
                default:
                    this.searchForm.sortingOrder = 'asc';
                    this.searchForm.sortField = 'travelDate';
                    break;
            }
        }
    },
    methods: {
        searchSubmit () {
            this.isSearchFormSubmitted = true;
            this.$v.searchForm.$touch();

            if(!this.$v.searchForm.$invalid) {
                this.searchForm.fromTravelDate = this.searchForm.fromTravelDate == ''? '' : convertoEnDate(this.searchForm.fromTravelDate);
                this.searchForm.toTravelDate = this.searchForm.toTravelDate == ''? '' : convertoEnDate(this.searchForm.toTravelDate);
                this.searchForm.page = 1;
                this.isSearchApiInProgress = true;
                if (this.search.fromAirportId && this.search.fromAirportId?.airportCode) {
                    setItemSessionStorage(SessionKeys.travelCompanion.fromAirportCode, JSON.stringify(this.search.fromAirportId));
                }
                if (this.search.toAirportId && this.search.toAirportId?.airportCode) {
                    setItemSessionStorage(SessionKeys.travelCompanion.toAirportCode, JSON.stringify(this.search.toAirportId));
                }
                if (this.search.airlineName && this.search.airlineName.airlineName) {
                    setItemSessionStorage(SessionKeys.travelCompanion.airlineObj, JSON.stringify(this.search.airlineName));
                }
                this.searchForm.fromAirportCode = this.search.fromAirportId?.airportCode || "";
                this.searchForm.toAirportCode = this.search.toAirportId?.airportCode || "";
                this.searchForm.airlineName = this.search.airlineName?.airlineName || "";
                Vue.nextTick(()=>{
                    document.getElementById('searchForm').submit();
                })
            }
        },
        resetSubmit () {
            this.searchForm = {...SearchForm};
            this.isSearchApiInProgress = false;
            this.isSearchFormSubmitted = false;
            this.search.fromAirportId = null;
            this.search.toAirportId = null;
            this.search.airlineName = null;            
            deleteSessionStore(SessionKeys.travelCompanion.fromAirportCode);
            deleteSessionStore(SessionKeys.travelCompanion.toAirportCode);
            deleteSessionStore(SessionKeys.travelCompanion.airlineObj);
        },
        sortNsubmit(field) {
            if(field) {
                switch (field) {
                    case 'hitCount':
                        this.searchForm.sortingOrder = this.searchForm.sortField == 'hitCount' && this.searchForm.sortingOrder == 'asc' ? 'desc' : 'asc';
                        this.searchForm.sortField = 'hitCount';
                        break;
                
                    default:
                        this.searchForm.sortingOrder = this.searchForm.sortField == 'travelDate' && this.searchForm.sortingOrder == 'asc' ? 'desc' : 'asc';
                        this.searchForm.sortField = 'travelDate';
                        break;
                }
                Vue.nextTick(() => {
                    document.getElementById('searchForm').submit();
                });
            } else {
                setTimeout(() => {
                    document.getElementById('searchForm').submit();
                }, 1000);
            }
        }
    }
})
const ReplyForm = {
    travelCompanionId: immiObj.post?.travelcompanionId || 0,
    email: '',
    contactNumber: '',
    message: '',
    capchaCode: '',
    language: immiObj?.currentLangCode || 'en'
};
Vue.component('travel-companion-post', {
    mixins: [addTravelCompanion],
    components: {
        Spinner,
        'v-checkbox': Checkbox,
        Snackbar
    },
    data() {
        return {
            replyForm: {
                ...ReplyForm
            },
            isFormSubmitted: false,
            isApiInProgress: false,
            captchaRan: new Date().getTime(),
            repliedToPost: false,
            errors: []
        }
    },
    validations () {
        const self = this;
        let validations = {
            replyForm: {
                email: {
                    required,
                    email
                },
                contactNumber: {                    
                    
                },
                message: {
                    required
                },
                capchaCode: {}
            }
        };

        validations = {
            ...validations,...AddTCvalidation
        }

        if (!isUserLoggedIn.isLoggedIn) {
            validations.replyForm.capchaCode.required = required;
        }
        
        return validations;
    },
    created() {

    },
    methods: {
        replyToPost () {
            this.isFormSubmitted = true;
            this.$v.replyForm.$touch();
            this.errors = [];

            if(!this.$v.replyForm.$invalid) {
                this.isApiInProgress = true;
                this.$http.post(ApiUrls.travelCompanion.replyToPost, this.replyForm).then(res => {
                    const response = res.body;
                    this.isApiInProgress = false;
                    if(response.message === "error") {
                        this.resetCapcha();
                        this.$v.$reset();
                        this.errors = response.error || ['Something went wrong! Please try again.'];
                    } else {
                        this.repliedToPost = true;
                        this.resetForm();
                    }
                }, err => {
                    this.$v.$reset();
                    const response = err.body;
                    this.resetCapcha();
                    this.isApiInProgress = false;
                    this.errors = response.error || ['Something went wrong! Please try again.'];
                })
            } else {
                // goToFirstError();
            }
        },
        resetForm () {
            this.replyForm = {
                ...ReplyForm
            };
            this.isApiInProgress = false;
            this.isFormSubmitted = false;
            this.errors = [];
            this.resetCapcha();
            this.$v.$reset();
        },
        resetCapcha () {
            this.replyForm.capchaCode = "";
            this.captchaRan = new Date().getTime();
        }
    }
})